import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class WishlistTogglerComponent extends Component {

  get SELECTORS() {
    return {
      main: '.wish-switch',
    };
  }

  constructor() {
    super();
    this.onWishlistClass = 'on-wishlist';
    this.trackingComponent = new TrackingComponent();
  }

  initToggler() {
    let allHearts = document.querySelectorAll(this.SELECTORS.main);
    let cssClass = this.onWishlistClass;
    for (let heart of allHearts) {
      heart.addEventListener('click', (e) => {
        if (!heart.classList.contains('on-wishlist')) {
          let heartLink = e.currentTarget.querySelector('[data-code]');
          this.trackingComponent.trackAction('wishlistAdd', heartLink.dataset, heartLink);
        }
        heart.classList.toggle(cssClass);
      })
    }
  }

  render() {

    if (document.querySelector(this.SELECTORS.main)) {
      this.initToggler();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
